






























import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'
import UchinokoIcon from '@/components/Event/Uchinoko/Icon'
import Checkbox from '@/components/shared/atoms/Checkbox'
import CartQueryEntity from '@/entities/C4'

// usecases
import UpdateSelectedUchinokoFacesUseCase from '@/usecases/event/UpdateSelectedUchinokoFacesUseCase'

// entities
import ChildEntity from '@/entities/Child'

export default Vue.extend({
  components: {
    UchinokoIcon,
    Checkbox
  },
  props: {
    eventId: {
      type: Number,
      required: true
    },
    childrenList: {
      type: Array as () => ChildEntity[],
      default: null
    },
    hasAdminPrivilege: {
      type: Boolean,
      default: null
    },
    adminId: {
      type: Number,
      default: null
    },
    hasOrderHistory: {
      type: Boolean,
      default: false
    },
    isUchinokoJump: {
      type: Boolean,
      default: false
    },
    cartQueryStatus: {
      type: Object as () => CartQueryEntity[] | null,
      default: null
    },
    isProfileImageRegisteredNotProfileSearchEnable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        profileRepository: this.$profileRepository,
        groupRepository: this.$groupRepository,
        eventRepository: this.$eventRepository,
        eventId: this.eventId
      })
    }
  },
  methods: {
    async handleSelectedUchinokoFacesChange(faceId: string, value: boolean) {
      const usecase = new UpdateSelectedUchinokoFacesUseCase({
        eventRepository: this.$eventRepository
      })
      const selectedFaces = await usecase.execute({
        eventId: this.eventId,
        data: { [faceId]: value }
      })
      const hasSelectedFaces = Object.values(selectedFaces).filter(Boolean).length

      // かお選択件数が0件になったらトーストを表示
      if (!hasSelectedFaces) {
        this.$toastRepository.addQueue({
          type: 'info',
          text: 'かお検索を非表示にしました'
        })
      }
    },
    handleClick() {
      // 顔検索設定画面に遷移。顔検索設定の変更後にイベント詳細に戻れるようにするため、クエリパラメータを付与
      if (this.adminId) this.$router.push({ path: `/families/${this.adminId}/settings/uchinoko`, query: { eventId: String(this.eventId) } })
    },
    disabledCheck(faceId: number) {
      /* iconに対する検索結果枚数が0枚のとき、labelとcheckboxをdisabledにする */
      if (!this.presenter.faceEventPhotos[faceId]) {
        return true
      }
      return false
    }
  }
})
